export enum FloaterIndex {
    Fixed = 'Fixed',
    Sofr = 'SOFR',
    Sonia = 'SONIA',
    Libor = 'LIBOR',
    Euribor = 'EURIBOR',
}
